import { render, staticRenderFns } from "./RegionPage.vue?vue&type=template&id=78c84187&scoped=true&"
import script from "./RegionPage.vue?vue&type=script&lang=js&"
export * from "./RegionPage.vue?vue&type=script&lang=js&"
import style0 from "./RegionPage.vue?vue&type=style&index=0&id=78c84187&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c84187",
  null
  
)

export default component.exports